var React = require('react');

function ThreeDots (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.91936 3.92534C7.91936 6.08876 6.16618 7.84719 3.99822 7.84719C1.83271 7.84719 0.078125 6.08876 0.078125 3.92534C0.078125 1.75493 1.83271 0 3.99822 0C6.16618 0 7.91936 1.75493 7.91936 3.92534Z","fill":"#231F20","key":0}),React.createElement("path",{"d":"M21.4221 3.92534C21.4221 6.08876 19.6651 7.84719 17.501 7.84719C15.3324 7.84719 13.5781 6.08876 13.5781 3.92534C13.5781 1.75493 15.3324 0 17.501 0C19.6651 0 21.4221 1.75493 21.4221 3.92534Z","fill":"#231F20","key":1}),React.createElement("path",{"d":"M34.9229 3.92534C34.9229 6.08876 33.1676 7.84719 31.0017 7.84719C28.8334 7.84719 27.0781 6.08876 27.0781 3.92534C27.0781 1.75493 28.8334 0 31.0017 0C33.1676 0 34.9229 1.75493 34.9229 3.92534Z","fill":"#231F20","key":2})]);
}

ThreeDots.defaultProps = {"width":"35","height":"8","viewBox":"0 0 35 8","fill":"none"};

module.exports = ThreeDots;

ThreeDots.default = ThreeDots;
